<script>
export default {
  props: {
    campaignOverview: {
      type: Object,
      required: true,
    },
  },
  computed: {
    audienceCity() {
      if (!this.campaignOverview.audience_city) {
        return [];
      }

      const audienceCity = this.campaignOverview.audience_city;
      const total = audienceCity.reduce((result, item) => {
        result += item.value;
        return result;
      }, 0)

      return audienceCity
          .map(audienceCity => {
            audienceCity.percentage = (audienceCity.value * 100 / total)
            return audienceCity
          })
          .sort((a, b) => new Date(b.value) - new Date(a.value))
    }
  },
  created() {
  }
}
</script>

<template>
  <div class="card flex-fill">
    <div class="card-body">
      <h4 class="card-title mb-4">Top Cities</h4>

      <div v-if="audienceCity && audienceCity.length > 0">
        <div class="text-center">
          <div class="mb-4">
            <i class="bx bx-map-pin text-primary display-4"></i>
          </div>
          <h3>{{ audienceCity[0].value }}</h3>
          <p>{{ audienceCity[0].city.split(',')[0] }}</p>
        </div>

        <div class="table-responsive mt-4">
          <table class="table table-centered">
            <tbody>
            <tr v-for="audience in audienceCity.slice(0, 3)" :key="audience.city">
              <td style="width: 140px">
                <p class="mb-0">{{ audience.city.split(',')[0] }}</p>
              </td>
              <td style="width: 120px">
                <h5 class="mb-0">{{ audience.percentage.toFixed(1) }}%</h5>
              </td>
              <td>
                <b-progress :value="audience.percentage" variant="primary" height="5px"></b-progress>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else class="">
        <h2 class="text-center text-muted">N/A</h2>
      </div>

    </div>
  </div>
</template>
